export default __webpack_public_path__ + "static/media/Group2131-tata-neu@2x.b411b90e.png";